import { registerGtmDataLayer } from "../../../../Blocks/Video/gtmDataLayerService"

export default function (eventCategory, eventAction, eventLabel, collaborationState, piName) {
    console.log('GTMregisterTotalkredit', eventCategory, eventAction, eventLabel, collaborationState)
    const message = {
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel ? eventLabel.toLowerCase() : '',
        eventValue: 0,
        eventNoninteraction: true,
        collaborationState: collaborationState,
        event: 'track-event'
    }

    if (eventCategory == 'find rådgiver') {
        message.piName = piName
    }

    registerGtmDataLayer(message)
}